import './App.scss';
import ClaycoSecureApp from 'clayco-secure-app';
import { ThemedApp } from 'clayco-bootstrap-app/dist/index';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import { reactPlugin } from './AppInsights';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';

function App() {
  return (
    <div className="App">
      <ClaycoSecureApp>
        <AppInsightsContext.Provider value={reactPlugin}>
          <ThemedApp title={'WorkSafe'}
            useIdentity
              /*
              To Include header navigation:
              headerNavItems={
                <>
                <MenuItem path="/" title="title" />
                </>
              }
              
              To Include side panel navigation:
              sideNavItems={
                <>
                <MenuItem path="/" title="title"/>
                </>
              }

              To Include breadcrumbs:
              breadcrumbs={
                <>
                <Breadcrumb title='Step 1' path='/Step1' status='complete/current/incomplete'/>
                <Breadcrumb title='Step 2' path='/Step2' status='complete/current/incomplete'/>
                <Breadcrumb title='Step 3' path='/Step3' status='complete/current/incomplete'/>
                </>
              }

              To Include progress bar:
              useProgressBar
            */
            >
            <Routes>
              <Route exact path="/" element={<Home/>} />
            </Routes>
          </ThemedApp>
        </AppInsightsContext.Provider>
      </ClaycoSecureApp>
    </div>
  );
}

export default App;
